import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-h5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "No Records found", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_order_detail = _resolveComponent("order-detail")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_data_table = _resolveComponent("v-data-table")!

  return (_openBlock(), _createBlock(_component_v_card, { flat: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            elevation: 4,
            class: "rounded-lg"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_data_table, {
                "rounded-pill": "",
                headers: _ctx.headers,
                items: _ctx.orders,
                "sort-by": [{ key: 'date', order: 'desc' }],
                class: "elevation-1"
              }, {
                top: _withCtx(() => [
                  _createVNode(_component_v_toolbar, { flat: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_toolbar_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Orders")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_divider, {
                        class: "mx-4",
                        inset: "",
                        vertical: ""
                      }),
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_v_dialog, {
                        modelValue: _ctx.dialog,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dialog) = $event)),
                        "max-width": "800px"
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn, _mergeProps({
                            color: "primary",
                            dark: "",
                            class: "mb-2"
                          }, props, { "prepend-icon": "mdi-plus" }), {
                            default: _withCtx(() => [
                              _createTextVNode(" New ")
                            ]),
                            _: 2
                          }, 1040)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card_title, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.formTitle), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_card_text, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_container, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_order_detail, {
                                        orders: _ctx.editedItem,
                                        onUpdateOrder: _ctx.onUpdateOrder
                                      }, null, 8, ["orders", "onUpdateOrder"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_card_actions, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_spacer),
                                  _createVNode(_component_v_btn, {
                                    color: "blue-darken-1",
                                    variant: "text",
                                    onClick: _ctx.close
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Cancel ")
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"]),
                                  _createVNode(_component_v_btn, {
                                    color: "blue-darken-1",
                                    variant: "text",
                                    onClick: _ctx.save
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Save ")
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_v_dialog, {
                        modelValue: _ctx.dialogDelete,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialogDelete) = $event)),
                        "max-width": "500px"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card_title, { class: "text-h5" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Are you sure you want to delete this row?")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_card_actions, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_spacer),
                                  _createVNode(_component_v_btn, {
                                    color: "blue-darken-1",
                                    variant: "text",
                                    onClick: _ctx.closeDelete
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Cancel")
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"]),
                                  _createVNode(_component_v_btn, {
                                    color: "blue-darken-1",
                                    variant: "text",
                                    onClick: _ctx.deleteItemConfirm
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("OK")
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"]),
                                  _createVNode(_component_v_spacer)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                [`item.actions`]: _withCtx(({ item }) => [
                  _createVNode(_component_v_icon, {
                    size: "small",
                    class: "me-2",
                    onClick: ($event: any) => (_ctx.editItem(item.raw))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" mdi-pencil ")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_v_icon, {
                    size: "small",
                    onClick: ($event: any) => (_ctx.deleteItem(item.raw))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" mdi-delete ")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                "no-data": _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["headers", "items"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}